import { ApolloError, ApolloQueryResult, useQuery } from "@apollo/client";
import { useMemo } from "react";
import Consultation from "../../../data-model/types/consultation/Consultation";
import { APIConsultation } from "../consultations";
import { QUERY_FETCH_CONSULTATION_FOR_CALL_BY_UUID } from "../queries";

interface IFetchConsultationByUuidData {
  consultation: Consultation | undefined;
  error: ApolloError | undefined;
  loading: boolean;
  refetch: (
    variables?: APIConsultation.Fetch.InputByUuid | undefined,
  ) => Promise<ApolloQueryResult<APIConsultation.Fetch.ResultByUuid>>;
}

export default function useFetchConsultationByUuid(
  uuid: string,
): IFetchConsultationByUuidData {
  const { data, error, loading, refetch } = useQuery<
    APIConsultation.Fetch.ResultByUuid,
    APIConsultation.Fetch.InputByUuid
  >(QUERY_FETCH_CONSULTATION_FOR_CALL_BY_UUID, {
    variables: { uuid },
  });

  const consultationToReturn = useMemo(() => {
    if (!loading && data) {
      const { consultation } = data;

      return new Consultation(consultation);
    }
  }, [loading, data]);

  return {
    consultation: consultationToReturn,
    error,
    loading,
    refetch,
  };
}
